/**
 * @generated SignedSource<<03ca7c4ab2d8aa6d7329b75757463944>>
 * @relayHash a753d2378b8a0e85d368b587cef149cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type sprintJqlBuilderBasicFieldValuesQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  jql: string;
  jqlTerm: string;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type sprintJqlBuilderBasicFieldValuesQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly sprint?: {
              readonly boardName: string | null | undefined;
              readonly state: JiraSprintState | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type sprintJqlBuilderBasicFieldValuesQuery = {
  response: sprintJqlBuilderBasicFieldValuesQuery$data;
  variables: sprintJqlBuilderBasicFieldValuesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v12 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v13 = {
  "kind": "ScalarField",
  "name": "state"
},
v14 = {
  "kind": "ScalarField",
  "name": "boardName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "sprintJqlBuilderBasicFieldValuesQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v7/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v8/*: any*/),
                  "concreteType": "JiraJqlFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    (v10/*: any*/),
                    {
                      "concreteType": "JiraJqlFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v11/*: any*/),
                            (v12/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSprint",
                                  "kind": "LinkedField",
                                  "name": "sprint",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/),
                                    (v14/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraJqlSprintFieldValue"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "sprintJqlBuilderBasicFieldValuesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df",
    "metadata": {},
    "name": "sprintJqlBuilderBasicFieldValuesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2fca268b01a9949b7d6a9c7abb665ff1";

export default node;
